import { gql } from 'graphql-request';

export const DELETE_ORGANIZATION_DOCUMENT = gql`
  mutation CoreOrganizationDocuments($id: ID!) {
    coreOrganizationDocuments {
      delete(id: $id)
    }
  }
`;
